export default [
  {
    path: '/article',
    name: 'article',
    component: () => import('@/views/article/article.vue'),
    meta: { title: '文章' }
  }
]
